import type { HTMLAttributes } from 'react';

/** 波形模式 */
export type WaveformMode = 'scrolling' | 'static';

/** LiveWaveform 组件 Props */
export interface LiveWaveformProps extends Omit<HTMLAttributes<HTMLDivElement>, 'onError'> {
  /** 是否激活（开始录音） */
  active?: boolean;
  /** 是否处理中 */
  processing?: boolean;
  /** 外部传入的 AnalyserNode（如果传入则使用外部的，否则自己创建） */
  analyser?: AnalyserNode | null;
  /** 音频设备 ID */
  deviceId?: string;
  /** 柱状条宽度 */
  barWidth?: number;
  /** 柱状条高度（最小） */
  barHeight?: number;
  /** 柱状条间隙 */
  barGap?: number;
  /** 柱状条圆角 */
  barRadius?: number;
  /** 柱状条颜色 */
  barColor?: string;
  /** 是否启用边缘渐隐 */
  fadeEdges?: boolean;
  /** 渐隐宽度 */
  fadeWidth?: number;
  /** 组件高度 */
  height?: string | number;
  /** 灵敏度 */
  sensitivity?: number;
  /** 平滑时间常量 */
  smoothingTimeConstant?: number;
  /** FFT 大小 */
  fftSize?: number;
  /** 历史数据大小 */
  historySize?: number;
  /** 更新频率 (ms) */
  updateRate?: number;
  /** 波形模式 */
  mode?: WaveformMode;
  /** 错误回调 */
  onError?: (error: Error) => void;
  /** 音频流就绪回调 */
  onStreamReady?: (stream: MediaStream) => void;
  /** 音频流结束回调 */
  onStreamEnd?: () => void;
}

/** 默认配置 */
export const DEFAULT_CONFIG = {
  barWidth: 3,
  barGap: 1,
  barRadius: 1.5,
  barHeight: 4,
  height: 64,
  sensitivity: 1,
  smoothingTimeConstant: 0.8,
  fftSize: 256,
  historySize: 60,
  updateRate: 30,
  fadeWidth: 24,
  mode: 'static' as WaveformMode,
} as const;

/** 波形动画配置 */
export const ANIMATION_CONFIG = {
  /** 处理动画速度 */
  processingSpeed: 0.03,
  /** 过渡速度 */
  transitionSpeed: 0.02,
  /** 淡出速度 */
  fadeSpeed: 0.03,
  /** 最小值 */
  minValue: 0.05,
  /** 频率范围起点 */
  freqStart: 0.05,
  /** 频率范围终点 */
  freqEnd: 0.4,
} as const;
